import * as $ from 'jquery';
import 'jstorage';

class LocalStorageService {
    add(key: string, value: any, ttl?: number) {
        if (ttl) {

            $.jStorage.set(key, value, {TTL: ttl});
        } else {
            $.jStorage.set(key, value);
        }
    }

    get(key: string) {
        return $.jStorage.get(key);
    }

    remove(key: string) {
        $.jStorage.deleteKey(key);
    }
}


export default new LocalStorageService();
